import { useGetSpendingLimits } from '../../hooks/useGetSpendingLimits';
import styles from '../SpendingLimitCard.module.css';

type TSpendingLimitStatus = 'valid' | 'declined' | 'expired';

export const SpendingLimitBar = ({
    status
}: {
    status: TSpendingLimitStatus;
}) => {
    const { activeSpendingLimit, loadingSpendingLimits } =
        useGetSpendingLimits();

    if (loadingSpendingLimits || !activeSpendingLimit) return null;

    const creditPercentageUsed = activeSpendingLimit.spent_amount_percentage;

    const mapStatusToColor = (status: TSpendingLimitStatus) => {
        switch (status) {
            case 'valid':
                return 'secondary-60';
            case 'expired':
                return 'structure-60';
            case 'declined':
                return 'primary-10';
        }
    };

    const creditLimitBarBackground = {
        background: `linear-gradient(
            to right, var(--color-${mapStatusToColor(status)}) ${
                status === 'declined' ? 100 : creditPercentageUsed
            }%, 
            var(--color-structure-95) ${
                status === 'declined' ? 100 : creditPercentageUsed
            }%, 
            var(--color-structure-95) 100%)`
    } as React.CSSProperties;
    return (
        <div
            className={styles.creditLimitBar}
            style={creditLimitBarBackground}
        ></div>
    );
};
